import { render, staticRenderFns } from "./MailTemplateList.vue?vue&type=template&id=10d50c24&scoped=true"
import script from "./MailTemplateList.vue?vue&type=script&lang=js"
export * from "./MailTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d50c24",
  null
  
)

export default component.exports